import * as AntIcons from '@ant-design/icons';

const DynamicIcon = ({ icon }) => {
  if (!icon) return ""
  const AntIcon = AntIcons[icon];
  return <AntIcon />
}

export default DynamicIcon